import { makeStyles } from "@material-ui/core";
import { createStyles } from "@material-ui/styles";
import React from "react";
import { CloseModal, HeaderModal, MainModal, ModalContent } from "./styles";

const useStyles = makeStyles(() =>
  createStyles({
    open: {
      display: "block",
    },
    close: {
      display: "none",
    },
  })
);

interface ICustomModal {
  open: boolean;
  backLabel?: React.ReactNode;
  children: React.ReactNode;
  onClose: () => void;
}

export default function CustomModal({ open, backLabel, children, onClose }: ICustomModal) {
  const styles = useStyles();
  return (
    <MainModal className={open ? styles.open : styles.close}>
      <ModalContent>
        <HeaderModal>
          <CloseModal onClick={onClose}>{backLabel}</CloseModal>
        </HeaderModal>
        {children}
      </ModalContent>
    </MainModal>
  );
}
